module.exports = __webpack_public_path__ + "cee99cdea55f4bdd4a685880b8d3882f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg16.jpeg
// module id = 24
// module chunks = 0